module.exports = __webpack_public_path__ + "static/media/dodgem(28).87440152.PNG";